import { GridColDef } from '@mui/x-data-grid';

import { TWithdrawal } from 'shared/services/types/withdrawal.types';

const FULL_TABLE_WIDTH = 1790;

export const COLUMNS_WITHDRAWALS: GridColDef<TWithdrawal.WithdrawalItem>[] = [
  {
    field: 'status',
    headerName: '',
    width: 76 / FULL_TABLE_WIDTH
  },
  {
    field: 'role',
    headerName: 'Type',
    width: 186 / FULL_TABLE_WIDTH
  },

  {
    field: 'id',
    headerName: 'ID',
    width: 166 / FULL_TABLE_WIDTH
  },
  {
    field: 'transaction_id',
    headerName: 'ID Transaction',
    width: 256 / FULL_TABLE_WIDTH
  },
  {
    field: 'Subagent_id',
    headerName: 'Subagent',
    width: 220 / FULL_TABLE_WIDTH
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 208 / FULL_TABLE_WIDTH
  },
  {
    field: 'account_id_from',
    headerName: 'Account from',
    width: 250 / FULL_TABLE_WIDTH
  },
  {
    field: 'account_id_to',
    headerName: 'Account to',
    width: 230 / FULL_TABLE_WIDTH
  },
  {
    field: 'created_at',
    headerName: 'Date',
    width: 200 / FULL_TABLE_WIDTH
  }
];
